(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.querySelector('.shopify-section-header');
			this.headerOverlay = document.querySelector('.header-overlay');
			this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
			this.headerBounds = {};
			this.currentScrollTop = 0;
			this.preventReveal = false;

			if (this.headerIsAlwaysSticky) {
				this.header.classList.add('shopify-section-header-sticky');
				this.header.classList.add('always-fixed');
				if (this.headerOverlay) {
					this.headerOverlay.classList.add('color-background-1');
					this.headerOverlay.classList.remove('color-inverse');
				}
			};

			this.onScrollHandler = this.onScroll.bind(this);
			this.hideHeaderOnScrollUp = () => this.preventReveal = true;
			this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.addEventListener('scroll', this.onScrollHandler, false);

			this.createObserver();
		}

		disconnectedCallback() {
			this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			observer.observe(this.header);
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
			requestAnimationFrame(this.reveal.bind(this));
			}else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
			}
			} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
			}

			this.currentScrollTop = scrollTop;
		}

		hide() {
			if (document.querySelector(".search-modal.active")) return;
			if (document.querySelector(".burger-drawer.active")) {
				this.header.classList.remove('shopify-section-header-hidden', 'animate');
			};
			if (document.querySelector(".burger-drawer.active")) return;
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
			this.closeMenuDisclosure();
			if (this.headerOverlay) {
				this.headerOverlay.classList.add('color-background-1');
			}
		}

		reveal() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
			if (this.headerOverlay) {
				this.headerOverlay.classList.add('color-background-1');
				this.headerOverlay.classList.remove('color-inverse');
			}
		}

		reset() {
			if (this.headerIsAlwaysSticky) return;
			this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
			if (this.headerOverlay) {
				this.headerOverlay.classList.remove('color-background-1');
				this.headerOverlay.classList.add('color-inverse');
			}
		}

		closeMenuDisclosure() {
			this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
			if (this.disclosures) {
				this.disclosures.forEach(disclosure => {
					disclosure.close(); 
				});
			}
			this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
				if (this.disclosureLists) {
					this.disclosureLists.forEach(disclosureList => {
						disclosureList.setAttribute('hidden', true); 
					});
				}
			this.disclosureButton = this.header.querySelectorAll('.disclosure__button');
			if (this.disclosureButton) {
				this.disclosureButton.forEach(disclosureButton => {
					disclosureButton.setAttribute('aria-expanded', false); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-pj-redesign"] && !Shopify.designMode) return;
  try {
    
var PJ = window.PJ_DATA;
var pjq = 1;

window.pjImg = function(el){
  var m = document.getElementById('pj-main-img');
  var thumbs = document.querySelectorAll('.pj-thumb');
  var stage = document.querySelector('.pj-stage');

  document.querySelectorAll('.pj-thumb').forEach(function(t){ t.classList.remove('active'); });
  el.classList.add('active');

  if(stage && thumbs.length){
    var isFirst = (el === thumbs[0]);
    stage.classList.toggle('hide-badges', !isFirst);
  }

  if(!m || !el.dataset.src || m.src === el.dataset.src) return;
  pjSwapImg(m, el.dataset.src);
};

function pjSwapImg(img, newSrc){
  var pre = new Image();
  pre.onload = function(){
    img.classList.add('slide-out');
    setTimeout(function(){
      img.classList.add('slide-in-prep');
      img.classList.remove('slide-out');
      img.src = newSrc;
      void img.offsetWidth;
      img.classList.remove('slide-in-prep');
    }, 450);
  };
  pre.onerror = function(){ img.src = newSrc; };
  pre.src = newSrc;
}

window.pjQty = function(d){
  pjq = Math.max(1, pjq + d);
  document.querySelectorAll('.pj-qnum').forEach(function(e){ e.textContent = pjq; });
  var qi = document.getElementById('pj-qi');
  if(qi) qi.value = pjq;
  pjUpdBtn();
};

window.pjVariant = function(btn){
  var oi = parseInt(btn.dataset.oi);
  btn.closest('[data-oi]').querySelectorAll('.pj-vbtn').forEach(function(b){ b.classList.remove('sel'); });
  btn.classList.add('sel');
  PJ.sopts[oi] = btn.dataset.val;
  var m = null;
  PJ.variants.forEach(function(v){
    var o = [v.option1, v.option2, v.option3].filter(Boolean);
    var ok = true;
    PJ.sopts.forEach(function(s, i){ if(s && o[i] !== s) ok = false; });
    if(ok) m = v;
  });
  if(m){
    PJ.cid = m.id;
    var inp = document.getElementById('pj-vid-' + PJ.sid);
    if(inp) inp.value = m.id;
    pjUpdPrice(m);
    pjUpdBtn(m);
    if(m.featured_image){
      var img = document.getElementById('pj-main-img');
      if(img && img.src !== m.featured_image.src){
        pjSwapImg(img, m.featured_image.src);
      }
    }
    if(history.replaceState) history.replaceState(null, null, '?variant=' + m.id);
  }
};

window.pjFaq = function(el){
  el.parentElement.classList.toggle('open');
};

window.pjVidScroll = function(dir){
  var track = document.getElementById('pj-vidtrack');
  if(!track) return;
  var card = track.querySelector('.pj-vidcard');
  if(!card) return;
  var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 16);
  var step = card.getBoundingClientRect().width + gap;
  var perClick = window.innerWidth > 900 ? 4 : 1;
  track.scrollBy({ left: dir * step * perClick, behavior: 'smooth' });
};

// ---- Mobile centred-card slider: flag whichever card is nearest the track's
// horizontal midpoint so CSS can scale it up and dim its neighbours.
window.pjVidCenterTick = null;

function pjVidCenter(){
  var track = document.getElementById('pj-vidtrack');
  if(!track) return;
  var cards = track.querySelectorAll('.pj-vidcard');
  if(window.innerWidth > 900){
    cards.forEach(function(c){ c.classList.remove('is-center'); });
    return;
  }
  var mid = track.getBoundingClientRect().left + track.clientWidth / 2;
  var best = null, bd = Infinity;
  cards.forEach(function(c){
    var r = c.getBoundingClientRect();
    var d = Math.abs(r.left + r.width / 2 - mid);
    if(d < bd){ bd = d; best = c; }
  });
  cards.forEach(function(c){ c.classList.toggle('is-center', c === best); });
}

function pjVidCenterThrottled(){
  if(window.pjVidCenterTick) return;
  window.pjVidCenterTick = requestAnimationFrame(function(){
    window.pjVidCenterTick = null;
    pjVidCenter();
  });
}

// ---- Park the mobile slider on the SECOND card at load so a sliver of both
// neighbours is visible straight away. Card 1 is one swipe to the right.
// The track has scroll-behavior:smooth in CSS, so we disable it for the jump.
function pjVidInitPos(){
  var track = document.getElementById('pj-vidtrack');
  if(!track || window.innerWidth > 900) return;
  var cards = track.querySelectorAll('.pj-vidcard');
  // Parking on card 2 only makes sense when there is a card on either side of
  // it. With one or two cards, leave the track where it is and just flag the
  // centred one.
  if(cards.length < 3){ pjVidCenter(); return; }

  var target = cards[1];
  var prev = track.style.scrollBehavior;
  track.style.scrollBehavior = 'auto';

  var tr = track.getBoundingClientRect();
  var cr = target.getBoundingClientRect();
  var delta = (cr.left + cr.width / 2) - (tr.left + tr.width / 2);
  track.scrollLeft = track.scrollLeft + delta;

  // Restore smooth scrolling on the next frame, after the jump has landed.
  requestAnimationFrame(function(){
    track.style.scrollBehavior = prev || '';
    pjVidCenter();
  });
}

window.pjToggleMute = function(videoEl){
  videoEl.muted = !videoEl.muted;
  var icon = videoEl.nextElementSibling;
  if(icon && icon.classList.contains('pj-vidmute')){
    icon.textContent = videoEl.muted ? '🔇' : '🔊';
  }
};

// ===== Fullscreen video lightbox =====
window.pjVlbCards = [];
window.pjVlbIndex = 0;

window.pjVlbOpen = function(cardEl){
  var cards = Array.prototype.slice.call(document.querySelectorAll('.pj-vidcard'));
  window.pjVlbCards = cards;
  window.pjVlbIndex = cards.indexOf(cardEl);
  var lb = document.getElementById('pj-vlb');
  if(lb){ lb.classList.add('open'); document.body.style.overflow = 'hidden'; }
  pjVlbLoad();
};

window.pjVlbClose = function(){
  var lb = document.getElementById('pj-vlb');
  var vid = document.getElementById('pj-vlb-video');
  if(vid){ vid.pause(); }
  if(lb){ lb.classList.remove('open'); document.body.style.overflow = ''; }
};

window.pjVlbNav = function(dir){
  var n = window.pjVlbCards.length;
  if(!n || window.pjVlbAnimating) return;
  window.pjVlbAnimating = true;

  var stage = document.querySelector('.pj-vlb-stage');
  var peeks = document.querySelectorAll('.pj-vlb-peek');
  // dir = 1 (next): content slides left. dir = -1 (prev): content slides right.
  var outClass = dir === 1 ? 'pj-slide-l' : 'pj-slide-r';
  var peekShift = dir === 1 ? 'pj-slide-shift-l' : 'pj-slide-shift-r';

  if(stage) stage.classList.add(outClass);
  peeks.forEach(function(p){ p.classList.add(peekShift); });

  setTimeout(function(){
    window.pjVlbIndex = (window.pjVlbIndex + dir + n) % n;
    pjVlbLoad();
    // Prep the incoming slide from the opposite side, then release to center.
    if(stage){
      stage.classList.remove(outClass);
      stage.classList.add(dir === 1 ? 'pj-slide-r' : 'pj-slide-l');
    }
    peeks.forEach(function(p){
      p.classList.remove(peekShift);
      p.classList.add(dir === 1 ? 'pj-slide-shift-r' : 'pj-slide-shift-l');
    });
    // Next frame: remove the prep classes so everything eases back to place.
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        if(stage){ stage.classList.remove('pj-slide-l','pj-slide-r'); }
        peeks.forEach(function(p){ p.classList.remove('pj-slide-shift-l','pj-slide-shift-r'); });
        window.pjVlbAnimating = false;
      });
    });
  }, 300);
};

function pjVlbLoad(){
  var cards = window.pjVlbCards;
  var n = cards.length;
  var card = cards[window.pjVlbIndex];
  if(!card) return;
  var vid = document.getElementById('pj-vlb-video');
  var muteBtn = document.getElementById('pj-vlb-mute');
  var likesWrap = document.getElementById('pj-vlb-likes');
  var likesNum = document.getElementById('pj-vlb-likes-num');
  if(vid){
    vid.src = card.dataset.src || '';
    vid.muted = false;
    vid.currentTime = 0;
    vid.play().catch(function(){ vid.muted = true; vid.play().catch(function(){}); });
  }
  if(muteBtn){ muteBtn.textContent = (vid && vid.muted) ? '🔇 Unmute' : '🔊 Mute'; }
  var likes = card.dataset.likes;
  if(likesWrap && likesNum){
    if(likes && likes.trim() !== ''){ likesNum.textContent = likes + ' Likes'; likesWrap.style.display = 'flex'; }
    else { likesWrap.style.display = 'none'; }
  }
  // Arrows are pointless with a single video, and with two the previous and
  // next card are the same one, so the peeks would mirror each other.
  var arrows = document.querySelectorAll('.pj-vlb-arrow');
  arrows.forEach(function(a){ a.style.display = n > 1 ? 'flex' : 'none'; });

  // Side-peek previews (previous / next), shown from three videos up.
  var peekL = document.getElementById('pj-vlb-peek-left');
  var peekR = document.getElementById('pj-vlb-peek-right');
  if(peekL && peekR){
    if(n > 2){
      var prev = cards[(window.pjVlbIndex - 1 + n) % n];
      var next = cards[(window.pjVlbIndex + 1) % n];
      peekL.src = prev.dataset.src || '';
      peekR.src = next.dataset.src || '';
      peekL.parentElement.style.display = 'block';
      peekR.parentElement.style.display = 'block';
      // Peeks are static previews — load a frame but never play. Only the
      // centered video plays.
      peekL.muted = true; peekR.muted = true;
      peekL.pause(); peekR.pause();
    } else {
      peekL.parentElement.style.display = 'none';
      peekR.parentElement.style.display = 'none';
    }
  }
}

window.pjVlbToggleMute = function(){
  var vid = document.getElementById('pj-vlb-video');
  var muteBtn = document.getElementById('pj-vlb-mute');
  if(!vid) return;
  vid.muted = !vid.muted;
  if(muteBtn){ muteBtn.textContent = vid.muted ? '🔇 Unmute' : '🔊 Mute'; }
};

window.pjToggleDesc = function(){
  var wrap = document.getElementById('pj-desc-wrap');
  var btn = document.getElementById('pj-read-more');
  var full = document.getElementById('pj-desc-full');
  if(!wrap || !btn) return;
  var expanded = wrap.classList.toggle('expanded');
  btn.textContent = expanded ? 'Read Less' : 'Read More';
  if(expanded){
    if(full) full.scrollTop = 0;
    wrap.scrollIntoView({behavior:'smooth', block:'start'});
  } else {
    wrap.scrollIntoView({behavior:'smooth', block:'start'});
  }
};

function pjFmt(c){ return '\u20b9' + (c / 100).toLocaleString('en-IN'); }

function pjUpdPrice(v){
  var el = document.getElementById('pj-price-' + PJ.sid);
  if(!el) return;
  var h = '<span class="pj-price">' + pjFmt(v.price) + '</span>';
  if(v.compare_at_price > v.price){
    var p = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
    h += '<span class="pj-compare">' + pjFmt(v.compare_at_price) + '</span><span class="pj-discount">' + p + '% OFF</span>';
  }
  el.innerHTML = h;
  var sp = document.getElementById('pj-sp');
  if(sp) sp.textContent = pjFmt(v.price);
}

function pjUpdBtn(v){
  v = v || PJ.variants.find(function(x){ return x.id === PJ.cid; });
  var btn = document.getElementById('pj-atc-' + PJ.sid);
  if(!btn || !v) return;
  btn.disabled = !v.available;
  btn.textContent = v.available ? 'Add to Bag \u2014 ' + pjFmt(v.price * pjq) : 'Sold Out';
}

function pjStars(n){
  var s = '';
  for(var i = 1; i <= 5; i++) s += i <= Math.round(n) ? '\u2605' : '\u2606';
  return s;
}

function pjLoadReviews(){
  var section = document.getElementById('pj-reviews-section');
  var grid = document.getElementById('pj-revs-grid');
  var aggEl = document.getElementById('pj-rev-agg');
  if(!grid) return;

  Promise.all([
    fetch(PJ.workerUrl + '?per_page=100&page=1').then(function(r){ return r.json(); }),
    fetch(PJ.workerUrl + '?per_page=100&page=2').then(function(r){ return r.json(); })
  ]).then(function(results){
    var all = [];
    results.forEach(function(d){ if(d.reviews) all = all.concat(d.reviews); });

    var revs = all.filter(function(r){
      return r.product_handle === PJ.handle && r.body && r.body.trim().length > 5;
    });
    var display = revs.filter(function(r){ return r.rating >= 4; });
    if(display.length === 0) display = revs;

    if(display.length === 0){
      if(section) section.style.display = 'none';
      return;
    }

    var sum = display.reduce(function(a, r){ return a + r.rating; }, 0);
    var avg = (sum / display.length).toFixed(1);
    var cnt = display.length;
    var se = document.getElementById('pj-star-display');
    var ae = document.getElementById('pj-avg-display');
    var ce = document.getElementById('pj-cnt-display');
    var rr = document.getElementById('pj-rating-row');
    if(se) se.textContent = pjStars(avg);
    if(ae) ae.textContent = avg;
    if(ce) ce.textContent = '(' + cnt + ' reviews)';
    if(rr) rr.style.display = 'flex';
    if(aggEl) aggEl.innerHTML = '<span style="color:var(--gold);font-size:20px;letter-spacing:2px;">' + pjStars(avg) + '</span>'
      + '<span style="font-family:Cormorant Garamond,serif;font-size:22px;font-weight:500;color:#1a1a1a;margin-left:6px;">' + avg + '</span>'
      + '<span style="font-size:13px;color:#9a9490;margin-left:6px;">(' + cnt + ' verified reviews)</span>';

    grid.innerHTML = display.slice(0, 6).map(function(r){
      var init = (r.author || 'C').charAt(0).toUpperCase();
      return '<div class="pj-rev">'
        + '<div class="pj-rquote">\u201c</div>'
        + '<div class="pj-rstars" style="font-size:16px;color:var(--gold);margin-bottom:14px;">' + pjStars(r.rating) + '</div>'
        + '<p class="pj-rtext">' + (r.body || '').trim() + '</p>'
        + '<div class="pj-rviewer">'
        + '<div class="pj-ravatar">' + init + '</div>'
        + '<div><div class="pj-rname">' + (r.author || 'Customer') + '</div>'
        + (r.product_title ? '<div class="pj-rloc">' + r.product_title + '</div>' : '')
        + '</div><div class="pj-rcheck">\u2713 Verified</div></div></div>';
    }).join('');
  }).catch(function(){
    if(section) section.style.display = 'none';
  });
}

// ---- Ingredient rail: arrows advance a full page of cards on desktop,
// one card on narrow screens. Measures the real card width so it stays
// correct across the breakpoints.
window.pjIngScroll = function(dir){
  var rail = document.getElementById('pj-ing-rail');
  if(!rail) return;
  var card = rail.querySelector('.pj-ing-card');
  if(!card) return;
  var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || 20);
  var step = card.getBoundingClientRect().width + gap;
  var perClick = window.innerWidth > 1100 ? 4 : (window.innerWidth > 900 ? 3 : 1);
  rail.scrollBy({ left: dir * step * perClick, behavior: 'smooth' });
};

// ---- Ingredient cards: slide the detail panel up from the bottom of the
// card. Only one card stays open at a time. Works from both the "+" on the
// card and the "−" inside the panel, since both sit within .pj-ing-card.
window.pjIngToggle = function(btn){
  var card = btn.closest('.pj-ing-card');
  if(!card) return;
  var wasOpen = card.classList.contains('open');

  document.querySelectorAll('.pj-ing-card.open').forEach(function(c){
    c.classList.remove('open');
    var t = c.querySelector('.pj-ing-toggle');
    if(t) t.setAttribute('aria-expanded', 'false');
  });

  if(!wasOpen){
    card.classList.add('open');
    var toggle = card.querySelector('.pj-ing-toggle');
    if(toggle) toggle.setAttribute('aria-expanded', 'true');
    var body = card.querySelector('.pj-ing-pbody');
    if(body) body.scrollTop = 0;
  }
};

document.addEventListener('DOMContentLoaded', function(){
  var hero = document.getElementById('pj-hero');
  var sticky = document.getElementById('pj-sticky');
  if(hero && sticky && window.IntersectionObserver){
    new IntersectionObserver(function(e){
      e.forEach(function(x){ sticky.classList.toggle('vis', !x.isIntersecting); });
    }, { threshold: 0.1 }).observe(hero);
  }
  if(window.IntersectionObserver){
    document.querySelectorAll('.pj-step,.pj-bcard,.pj-wstep,.pj-wtext').forEach(function(el){
      new IntersectionObserver(function(e){
        e.forEach(function(x){ if(x.isIntersecting) x.target.classList.add('vis'); });
      }, { threshold: 0.1 }).observe(el);
    });
  }

  document.querySelectorAll('.pj-faqs-dynamic details').forEach(function(det){
    det.style.cssText = 'background:white;border-radius:16px;border:1px solid rgba(0,0,0,0.06);overflow:hidden;margin-bottom:12px;';
    var sum = det.querySelector('summary');
    if(sum) sum.style.cssText = 'padding:20px 24px;font-size:15px;font-weight:500;color:#1a1a1a;cursor:pointer;list-style:none;display:flex;justify-content:space-between;align-items:center;';
  });

  pjLoadReviews();
  pjUpdBtn();

  // Esc closes any open ingredient panel (the video lightbox handles its own
  // Esc below and returns early when it is the thing that is open).
  document.addEventListener('keydown', function(e){
    if(e.key !== 'Escape') return;
    var lbOpen = document.getElementById('pj-vlb');
    if(lbOpen && lbOpen.classList.contains('open')) return;
    document.querySelectorAll('.pj-ing-card.open').forEach(function(c){
      c.classList.remove('open');
      var t = c.querySelector('.pj-ing-toggle');
      if(t) t.setAttribute('aria-expanded', 'false');
    });
  });

  // ---- UGC slider: the card sitting in the middle autoplays muted while the
  // slider is in view. Click a card to open the popup (with sound).
  var vidTrack = document.getElementById('pj-vidtrack');
  if(vidTrack){
    var vidCards = Array.prototype.slice.call(vidTrack.querySelectorAll('.pj-vidplayer'));
    if(vidCards.length && window.IntersectionObserver){
      var vidObs = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting){
            en.target.muted = true;
            en.target.play().catch(function(){});
          } else {
            en.target.pause();
          }
        });
      }, { root: null, threshold: 0.6 });
      vidCards.forEach(function(v){ vidObs.observe(v); });
    } else {
      vidCards.forEach(function(v){ v.muted = true; v.play().catch(function(){}); });
    }

    // Centred-card highlighting on mobile, parked on card 2 at load.
    pjVidInitPos();
    vidTrack.addEventListener('scroll', pjVidCenterThrottled, { passive: true });
    window.addEventListener('resize', pjVidCenterThrottled);
    // Re-park once posters/fonts have settled and the real widths are known.
    window.addEventListener('load', pjVidInitPos);
  }

  // Lightbox: close on backdrop click, Esc to close, arrow keys to navigate.
  var lb = document.getElementById('pj-vlb');
  if(lb){
    lb.addEventListener('click', function(e){
      if(e.target === lb) pjVlbClose();
    });
  }
  document.addEventListener('keydown', function(e){
    var open = lb && lb.classList.contains('open');
    if(!open) return;
    if(e.key === 'Escape') pjVlbClose();
    else if(e.key === 'ArrowLeft') pjVlbNav(-1);
    else if(e.key === 'ArrowRight') pjVlbNav(1);
  });

  // Ensure floating product video actually autoplays (some mobile browsers
  // block autoplay even when muted until a user gesture is registered).
  var fv = document.querySelector('.pj-float-video video');
  if(fv){
    var tryPlay = function(){ fv.play().catch(function(){}); };
    tryPlay();
    document.addEventListener('touchstart', tryPlay, { once: true });
    document.addEventListener('click', tryPlay, { once: true });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}

		hide() {
			super.hide();
			window.pauseAllMedia();
		}

		show(opener) {
			super.show(opener);
			this.showActiveMedia();
		}

		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			if (activeMedia) {
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
			}
			
			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
